import React from 'react'
import View from '../../../../../components/pdf/View'
import Line from '../../../../../components/pdf/Line'
import Text from '../../../../../components/pdf/Text'
import { Table, TableCol, TableRow } from '../../../../../components/pdf/Table'
import Separator from '../../../../../components/pdf/Separator'

const NP2 = () => {
  return (
    <View id="np2">
      <Separator weight={10} />

      <Text bold>Tabela 3 - Magnitude do risco ergonômico puro - descritivo e numérico:</Text>

      <Separator weight={5} />

      <Table width={'100%'} style={{ border: 'none' }}>
        <TableRow bgColor={'#e2e2e2'} useFontBaseColor>
          <TableCol width={'20%'} useFontBaseColor bgColor="#fff" style={{ borderLeft: '1px solid #fff' }}></TableCol>
          <TableCol width={'20%'} useFontBaseColor style={{ borderTop: '1px solid #333' }}>
            <Text bold align={'center'}>
              Ocasional
            </Text>
          </TableCol>
          <TableCol width={'20%'} useFontBaseColor style={{ borderTop: '1px solid #333' }}>
            <Text bold align={'center'}>
              Intermitente
            </Text>
          </TableCol>
          <TableCol width={'20%'} useFontBaseColor style={{ borderTop: '1px solid #333' }}>
            <Text bold align={'center'}>
              Habitual
            </Text>
          </TableCol>
          <TableCol
            width={'20%'}
            useFontBaseColor
            style={{ borderTop: '1px solid #333', borderRight: '1px solid #333' }}
          >
            <Text bold align={'center'}>
              Permanente
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol bgColor={'#e2e2e2'} useFontBaseColor>
            <Text bold align={'center'}>
              Leve
            </Text>
          </TableCol>
          <TableCol bgColor={'#00c3f8'} useFontBaseColor>
            <Text align={'center'}>Risco Irrelevante</Text>
          </TableCol>
          <TableCol bgColor={'#00ff00'} useFontBaseColor>
            <Text align={'center'}>Risco Baixo</Text>
          </TableCol>
          <TableCol bgColor={'#00ff00'} useFontBaseColor>
            <Text align={'center'}>Risco Baixo</Text>
          </TableCol>
          <TableCol bgColor={'#ffff00'} useFontBaseColor style={{ borderRight: '1px solid #333' }}>
            <Text align={'center'}>Risco Médio</Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol bgColor={'#e2e2e2'} useFontBaseColor>
            <Text bold align={'center'}>
              Moderado
            </Text>
          </TableCol>
          <TableCol bgColor={'#00ff00'} useFontBaseColor>
            <Text align={'center'}>Risco Baixo</Text>
          </TableCol>
          <TableCol bgColor={'#00ff00'} useFontBaseColor>
            <Text align={'center'}>Risco Baixo</Text>
          </TableCol>
          <TableCol bgColor={'#ffff00'} useFontBaseColor>
            <Text align={'center'}>Risco Médio</Text>
          </TableCol>
          <TableCol bgColor={'#fc9c3c'} useFontBaseColor style={{ borderRight: '1px solid #333' }}>
            <Text align={'center'}>Risco Alto</Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol bgColor={'#e2e2e2'} useFontBaseColor>
            <Text bold align={'center'}>
              Sério
            </Text>
          </TableCol>
          <TableCol bgColor={'#00ff00'} useFontBaseColor>
            <Text align={'center'}>Risco Baixo</Text>
          </TableCol>
          <TableCol bgColor={'#ffff00'} useFontBaseColor>
            <Text align={'center'}>Risco Médio</Text>
          </TableCol>
          <TableCol bgColor={'#fc9c3c'} useFontBaseColor>
            <Text align={'center'}>Risco Alto</Text>
          </TableCol>
          <TableCol bgColor={'#fc9c3c'} useFontBaseColor style={{ borderRight: '1px solid #333' }}>
            <Text align={'center'}>Risco Alto</Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol bgColor={'#e2e2e2'} useFontBaseColor>
            <Text bold align={'center'}>
              Severo
            </Text>
          </TableCol>
          <TableCol bgColor={'#ffff00'} useFontBaseColor>
            <Text align={'center'}>Risco Médio</Text>
          </TableCol>
          <TableCol bgColor={'#fc9c3c'} useFontBaseColor>
            <Text align={'center'}>Risco Alto</Text>
          </TableCol>
          <TableCol bgColor={'#fc9c3c'} useFontBaseColor>
            <Text align={'center'}>Risco Alto</Text>
          </TableCol>
          <TableCol bgColor={'#FF0000'} useFontBaseColor>
            <Text align={'center'}>Risco Crítico</Text>
          </TableCol>
        </TableRow>
      </Table>

      <Separator weight={10} />

      <Text>
        O risco puro é cruzado com os métodos de controle existentes, caso os mesmos existam, e definidos conforme
        tabela abaixo:
      </Text>

      <Separator weight={5} />

      <Text bold>Tabela 4 - Definição do nível de mitigação:</Text>
      <Separator weight={5} />

      <Table width={'100%'} useFontBaseColor>
        <TableRow useFontBaseColor>
          <TableCol width={'20%'} rowSpan="2" useFontBaseColor>
            <Text bold align={'center'}>
              Tipo de controle operacional
            </Text>
          </TableCol>
          <TableCol width={'10%'} rowSpan="2" useFontBaseColor>
            <Text bold align={'center'}>
              Nível de mitigação
            </Text>
          </TableCol>
          <TableCol colSpan="3" useFontBaseColor>
            <Text bold align={'center'} style={{ lineHeight: 2 }}>
              CRITÉRIOS
            </Text>
          </TableCol>
        </TableRow>

        <TableRow width={'50%'} useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text bold align={'center'} style={{ lineHeight: 3 }}>
              Equipamentos
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold align={'center'} style={{ lineHeight: 3 }}>
              Método
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold align={'center'} style={{ lineHeight: 3 }}>
              Pessoas
            </Text>
          </TableCol>
        </TableRow>

        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text align={'center'}>Efetivo</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>85%</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>
              Condições de segurança, plenamente atendidas no projeto; melhor tecnologia disponível
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>Melhor prática operacional disponível</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>Colaboradores treinados e com experiência</Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text align={'center'}>Implantado</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>65%</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>Equipamento seguro e incluído em uma agenda de manutenção preventiva</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>Método leva em consideração saúde e segurança</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>Colaboradores treinados</Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text align={'center'}>Documentado</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>45%</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>Equipamento pode ser modificado para um melhor impacto sobre saúde e segurança</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>Método desatualizado ou baseado em informações antigas</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>Colaboradores receberam apenas treinamento de integração</Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text align={'center'}>Informal</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>25%</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>Equipamento não inclui dispositivos de proteção coletiva</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>Método informal</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>Colaboradores sem treinamento</Text>
          </TableCol>
        </TableRow>
      </Table>

      <Separator weight={10} />

      <Text bold>Tabela 5 - Definição da classificação do risco final</Text>
      <Text>De acordo com a classificação do risco final, será classificado como risco Baixo e Alto</Text>

      <Separator weight={5} />

      <Table width={'100%'} useFontBaseColor>
        <TableRow bgColor={'#e2e2e2'} useFontBaseColor>
          <TableCol width={'15%'} useFontBaseColor>
            <Text bold align={'center'}>
              CLASSIFICAÇÃO DO RISCO FINAL
            </Text>
          </TableCol>
          <TableCol width={'10%'} useFontBaseColor>
            <Text bold align={'center'}>
              NÍVEL DO RISCO FINAL
            </Text>
          </TableCol>
          <TableCol width={'25%'} useFontBaseColor>
            <Text bold align={'center'}>
              CONDIÇÃO
            </Text>
          </TableCol>
          <TableCol width={'30%'} useFontBaseColor>
            <Text bold align={'center'}>
              AÇÃO
            </Text>
          </TableCol>
          <TableCol width={'20%'} useFontBaseColor>
            <Text bold align={'center'}>
              CLASSIFICAÇÃO DO SOC
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol bgColor={'#34cc34'}>
            <Text bold align={'center'}>
              1
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold align={'center'}>
              Irrelevante
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text>Risco irrelevante, sem potencial de causar danos à saúde dos trabalhadores.</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text>
              Nenhuma ação é requerida e nenhum registro documental precisa ser mantido. Pode ser sugerido orientação
              específica.
            </Text>
          </TableCol>
          <TableCol bgColor={'#e2e2e2'} useFontBaseColor>
            <Text bold align={'center'}>
              ACEITÁVEL
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol bgColor={'#fbfb33'}>
            <Text bold align={'center'}>
              2 a 6
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold align={'center'}>
              Baixo
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text>
              É considerada uma exposição dentro da normalidade, porém, devido à variabilidade de indivíduos há uma
              baixa probabilidade de ocorrer ação de risco.{' '}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text>
              Pode-se estudar a implantação de ações preventivas e monitorização do risco, ou manutenção das medidas já
              implantadas caso aplicável. Caso apareçam reclamações ou ocorrências deste risco, o prazo deve ser
              reduzido.
            </Text>
          </TableCol>
          <TableCol bgColor={'#e2e2e2'} useFontBaseColor>
            <Text bold align={'center'}>
              TOLERÁVEL
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol bgColor={'#fb2b2b'}>
            <Text bold align={'center'}>
              7 a 16
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold align={'center'}>
              Alto
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text>
              Situações consideradas como potencialmente causadora de lesões e acidentes que geram afastamentos
              temporários, de longos períodos ou incapacidades funcionais, bem como a morte.
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text>
              Além do estudo sistemático da atividade, deve haver um plano de melhoria de prazo curto ou imediato
              aprovado pela alta direção. A execução deve ser monitorada e avaliada até a eliminação ou minimização do
              risco.
            </Text>
          </TableCol>
          <TableCol bgColor={'#e2e2e2'} useFontBaseColor>
            <Text bold align={'center'}>
              NÃO ACEITÁVEL
            </Text>
          </TableCol>
        </TableRow>
      </Table>

      <Separator weight={10} />

      <Text bold>Tabela 6 - Legenda dos resultados da Análise Ergonômica</Text>

      <Separator weight={5} />

      <Table width={'100%'}>
        <TableRow useFontBaseColor>
          <TableCol bgColor={'#e2e2e2'} colSpan="3">
            <Text bold align={'center'}>
              LEGENDAS DOS RESULTADOS DAS ANÁLISES ERGONÔMICAS
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol bgColor={'#34cc34'} width={'33%'}>
            <Text bold align={'center'} style={{ lineHeight: 5 }}>
              AUSÊNCIA DE FATOR DE RISCO
            </Text>
          </TableCol>
          <TableCol bgColor={'#fbfb33'} width={'33%'}>
            <Text bold align={'center'}>
              PRESENÇA DE FATOR DE RISCO E/OU RISCO ERGONÔMICO BAIXO
            </Text>
          </TableCol>
          <TableCol bgColor={'#fb2b2b'} width={'33%'}>
            <Text bold align={'center'}>
              PRESENÇA DE RISCO ERGONÔMICO ALTO
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text align={'center'}>
              Será assim classificado quando não houver atividade que exponha o colaborador ao agente. Não constará em
              PGR. Não será gerado Plano de Ação.
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>
              Será assim classificado quando houver exposição ao fator de risco, porém após a aplicação da metodologia é
              concluído pela presença de risco Ergonômico baixo. Não constará em PGR. Será gerado Plano de Ação.
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>
              Será assim classificado quando houver exposição ao fator de risco e após a aplicação da metodologia é
              concluído pela presença do risco Ergonômico Alto. Constará em PGR. Será gerado Plano de Ação.
            </Text>
          </TableCol>
        </TableRow>
      </Table>
    </View>
  )
}

export default NP2
